import { Typography } from '@growdash/design-system/atoms';

export default function EmptyStateView() {
  return (
    <div>
      <div className="text-center">
        <Typography className="font-bold text-[2rem]">
          Start your day with fresh insights ☕️
        </Typography>
        <Typography className="!leading-[1.25] mt-6 text-tertiary font-medium text-xl">
          To see your personalized insights, select a cuisine and brand above.{' '}
          <br />
          Aisha will handle the rest
        </Typography>
      </div>
    </div>
  );
}
